"use strict";
var $dyn;
(function ($dyn) {
    var shell;
    (function (shell) {
        /**
         * Manages initializing and changing the CSS file and transitioning the display according to user preferences.
         */
        var DensityThemeManager = /** @class */ (function () {
            function DensityThemeManager() {
                var _this = this;
                this._navBarHeights = {
                    // References @navigationBarHeight in src/Resources/styles/lessImports/constants.less
                    // $dyn.boot.loadShell
                    "21": 33,
                    "30": 48,
                };
                this._previousTheme = "";
                this._previousDensity = "";
                this._themes = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14"];
                this._densities = ["21", "30"];
                this._defaultTheme = -1;
                this._defaultDensity = -1;
                this._urlDensity = "";
                this._urlTheme = "";
                // Sets the current density from the URL
                this._setCurrentDensity = function (densityValue) {
                    if (densityValue && _this._isDensityValid(densityValue)) {
                        _this._urlDensity = densityValue;
                        $dyn.setObservableValue($dyn.user(), "Density", densityValue);
                    }
                };
                // Return the current density value
                this._getCurrentDensity = function () {
                    var user = $dyn.user();
                    return user ? $dyn.value(user.Density) : _this._defaultDensity;
                };
                // Return the current theme value
                this._getCurrentTheme = function () {
                    var user = $dyn.user();
                    return user ? $dyn.value(user.Theme) : _this._defaultTheme;
                };
                this._getDefaultTheme = function () {
                    return _this._defaultTheme;
                };
                this._getDefaultDensity = function () {
                    return _this._defaultDensity;
                };
                this._getCurrentLocalTheme = function () {
                    var localCssObj;
                    var theme;
                    if ($dyn.shell.canUseLocalStorage) {
                        theme = localStorage.getItem("theme");
                        if (theme) {
                            localCssObj = JSON.parse(theme);
                        }
                    }
                    if (theme == null || $dyn.shell.isSingleThemed) {
                        // set default theme
                        _this._setDefautTheme();
                    }
                    else {
                        // tslint:disable-next-line: radix
                        _this._previousDensity = parseInt(localCssObj.cssLinkDensity);
                        // tslint:disable-next-line: radix
                        _this._previousTheme = parseInt(localCssObj.cssLinkTheme);
                    }
                    var coreCssLink = _this._getCoreCssLink(_this._previousDensity, _this._previousTheme);
                    if (!$dyn.shell.isSingleThemed) {
                        document.head.appendChild(coreCssLink);
                        // append any custom requested themes
                        _this._appendCustomCss(_this._previousDensity, _this._previousTheme);
                        coreCssLink.onload = function () {
                            $dyn.ui.theme.invalidate();
                            $dyn.shell.displayFirstRendering();
                        };
                    }
                };
                this._getCssId = function (cssType, densityValue, themeValue) {
                    var cssId = cssType + "_" + densityValue + "_" + themeValue;
                    if ($dyn.debug.useRTL) {
                        cssId = cssId + "_rtl";
                    }
                    if ($dyn.version.buildType === "debug") {
                        cssId = cssId + "_debug";
                    }
                    return cssId;
                };
                // Sets the current theme from the URL
                this._setCurrentTheme = function (themeValue) {
                    if (themeValue && _this._isThemeValid(themeValue)) {
                        _this._urlTheme = themeValue;
                        $dyn.setObservableValue($dyn.user(), "Theme", themeValue);
                    }
                };
                /**
                 * This is only used by SingleTheme apps and is specific to flipping RTL mode on and off.
                 * @internal
                 */
                this._singleThemeUpdate = function () {
                    _this._setDefautTheme();
                    // If a density or theme is given in the URL, override what is selected
                    var currentDensity = _this._urlDensity.length > 0 ? _this._urlDensity : _this._previousDensity;
                    var currentTheme = _this._urlTheme.length > 0 ? _this._urlTheme : $dyn.shell.buildThemeValue;
                    // get old theme name
                    var oldTheme = {
                        "coreLink": { "id": "core_" + currentDensity + "_" + currentTheme },
                    };
                    // get new Theme
                    var newTheme = {
                        "coreLink": _this._getCoreCssLink(currentDensity, currentTheme),
                    };
                    var replaceTheme = true;
                    if (!$dyn.util.isRTLMode()) {
                        var findLinkIdSuffix = $dyn.version.buildType === "debug" ? "_rtl_debug" : "_rtl";
                        // does the RTL link already exist
                        if (document.getElementById(oldTheme.coreLink.id + findLinkIdSuffix)) {
                            // need to update old theme link names to add rtl tag, since we are transitioning from RTL to non-rtl
                            oldTheme = {
                                "coreLink": { "id": oldTheme.coreLink.id + findLinkIdSuffix },
                            };
                        }
                        else {
                            // we are not in RTL mode and RTL link is not in the page so abort
                            replaceTheme = false;
                        }
                    }
                    else {
                        if (document.getElementById(oldTheme.coreLink.id + "_debug")) {
                            // need to update old theme link names
                            oldTheme = {
                                "coreLink": { "id": oldTheme.coreLink.id + "_debug" },
                            };
                        }
                    }
                    // Make sure the old theme is actually present before swapping out.
                    if (replaceTheme && document.getElementById(oldTheme.coreLink.id)) {
                        _this._replaceTheme(newTheme, oldTheme, currentDensity, currentTheme);
                    }
                    else if ($dyn.util.isFlightEnabled($dyn.reactGrid.featureName) && currentTheme && currentTheme !== "0") {
                        _this.updateReactTheme();
                    }
                };
                // Updates the base CSS file based on the current user settings for Theme and Density
                // This function will check if the current requested theme/density is the same as the current displayed theme/density
                // if it is not it will Apply the new CSSlink and remove the old link.
                // this applying is leveraged with the helper functions getCoreCSSLink to append the css link to the head
                // once applied it will also make use of fade out and fade in for he transitions.
                // validated = the new theme or density requested
                // self._previous = the currently enabled theme or density
                this._updateThemeAndDensity = function () {
                    var user = $dyn.user();
                    if (user) {
                        // If a density or theme is given in the URL, override what is selected
                        var currentDensity = _this._urlDensity.length > 0 ? _this._urlDensity : $dyn.value(user.Density);
                        var currentTheme = _this._urlTheme.length > 0 ? _this._urlTheme : $dyn.value(user.Theme);
                        // Verify the density and theme are valid before changing out the CSS.
                        // If they are not valid, return the default values
                        var validated = _this._getValidThemeAndDensity(currentTheme, currentDensity);
                        // if old and new are not the same and not default settings
                        if ((_this._previousDensity !== validated.density ||
                            _this._previousTheme !== validated.theme) &&
                            validated.theme !== _this._defaultTheme &&
                            validated.density !== _this._defaultDensity) {
                            // gather the new theme
                            var coreCssLink = _this._getCoreCssLink(validated.density, validated.theme);
                            var newTheme = { "coreLink": coreCssLink };
                            // calculate the old theme
                            var coreCssId = _this._getCssId("core", _this._previousDensity, _this._previousTheme);
                            var oldCoreTheme = document.getElementById(coreCssId);
                            var oldTheme = { "coreLink": oldCoreTheme };
                            // Set the new Theme
                            _this._replaceTheme(newTheme, oldTheme, validated.density, validated.theme);
                        }
                        _this._previousDensity = validated.density;
                        _this._previousTheme = validated.theme;
                        $(document).trigger("densitychanged", validated.density);
                        $dyn.ui.theme.invalidate();
                    }
                };
                // Maps the AX Theme to the React Theme
                this.updateReactTheme = function () {
                    var currentTheme = $dyn.ui.theme.get();
                    if (currentTheme) {
                        // Wait for the resources to be loaded before updating the theme
                        $.when($dyn.deferred.onTrue(function () {
                            return $dyn.value($dyn.util.controlLibraryResourcesLoaded);
                        })).done(function () {
                            ControlLibrary.ThemeManager.instance.setCurrentTheme("AXTheme", {
                                colors: {
                                    Accent: currentTheme.accent,
                                    AccentDark: currentTheme.accentDark,
                                    AccentDarkDark: currentTheme.accentDarkDark,
                                    AccentLight: currentTheme.accentLight,
                                    AccentLightLight: currentTheme.accentLightLight,
                                    AlertError: currentTheme.errorStatusColor,
                                    AlertWarning: currentTheme.warningStatusColor,
                                    button: {
                                        BorderFocused: currentTheme.dark,
                                        icon: currentTheme.accent,
                                        iconHover: currentTheme.reactGridLink,
                                        lightIcon: {
                                            disabled: {
                                                Color: currentTheme.disabled,
                                            },
                                            enabled: {
                                                Color: currentTheme.darkGray6,
                                            },
                                        },
                                        lightPrimary: {
                                            enabled: {
                                                Color: currentTheme.accentDarkDark,
                                            },
                                        },
                                        lightSecondary: {
                                            disabled: {
                                                Color: currentTheme.disabled,
                                            },
                                            enabled: {
                                                Color: currentTheme.darkGray6,
                                            },
                                        },
                                        pressed: currentTheme.buttonDefaultPressedBackground,
                                        primary: {
                                            disabled: { BackgroundColor: currentTheme.darkGray },
                                            enabled: {
                                                active: {
                                                    BackgroundColor: currentTheme.buttonPressedBackground,
                                                    Color: currentTheme.light,
                                                },
                                                BackgroundColor: currentTheme.buttonBackgroundColor,
                                                Color: currentTheme.accent,
                                                hover: { BackgroundColor: currentTheme.buttonToggledBackground },
                                            },
                                        },
                                        secondary: {
                                            disabled: {
                                                BackgroundColor: currentTheme.appBarDisabledColor,
                                                Color: currentTheme.darkGray6,
                                            },
                                            enabled: {
                                                active: {
                                                    BackgroundColor: currentTheme.lightGray4,
                                                    Color: currentTheme.light,
                                                },
                                                BackgroundColor: currentTheme.lightGray,
                                                Color: currentTheme.darkGray,
                                                hover: {
                                                    BackgroundColor: currentTheme.lightGray3,
                                                },
                                            },
                                        },
                                    },
                                    card: {
                                        footer: {
                                            backgroundColor: currentTheme.accent,
                                        },
                                    },
                                    checkBox: {
                                        Color: currentTheme.listActiveCheckboxColor,
                                        disabled: { Color: currentTheme.disabled },
                                        focused: { Color: currentTheme.checkBoxViewModeColor },
                                        hovered: { Color: currentTheme.checkBoxViewModeColor },
                                        notEditable: { Color: currentTheme.checkBoxViewModeColor }
                                    },
                                    comboBox: {
                                        item: {
                                            ActiveBackgroundColor: currentTheme.toolbarHover,
                                            ActiveColor: currentTheme.toolbarText,
                                            HoveredBackgroundColor: currentTheme.toolbarHover,
                                            HoveredColor: currentTheme.toolbarText,
                                        }
                                    },
                                    dialog: { header: { BackgroundColor: currentTheme.lightGray2 } },
                                    FocusedBorderColor: currentTheme.focusOutlineColor,
                                    grid: {
                                        borderColor: currentTheme.borderColor,
                                        checkBox: {
                                            disabledColor: currentTheme.checkboxDisabledHover,
                                            hoveredColor: currentTheme.checkboxEnabledHover,
                                        },
                                        columnHeader: {
                                            TextColor: currentTheme.darkDarkGray,
                                            TextColorOnHover: currentTheme.columnHeaderTextOnHover,
                                        },
                                        footer: {
                                            buttonBackgroundColor: currentTheme.lightGray2,
                                            buttonBorderColor: currentTheme.lightGray4,
                                            hoverButtonBackgroundColor: currentTheme.lightGray0,
                                            hoveredSVGColor: currentTheme.darkDarkGray,
                                            svgColor: currentTheme.darkGray9,
                                        },
                                        header: {
                                            BackgroundColor: currentTheme.white,
                                            BorderColor: currentTheme.focusOutlineColor,
                                            Color: currentTheme.labelTextColor,
                                        },
                                        image: { PlaceholderColor: currentTheme.darkGray },
                                        linesColor: currentTheme.borderColor,
                                        markingColumn: {
                                            activeMarkedBackgroundColor: currentTheme.accentLightLight,
                                            headerCheckboxBorderColor: currentTheme.labelTextColor,
                                            inactiveMarkedBackgroundColor: currentTheme.accentLightLightLight,
                                            markedListBackgroundColor: currentTheme.accent,
                                            markedSVGBackgroundColor: currentTheme.accent,
                                            selectedHoverCheckboxBorderColor: currentTheme.selectedHoverCheckboxBorderColor,
                                            selectedHoverMarkedCheckboxBackgroundColor: currentTheme.checkBoxHoverOnColor,
                                            unselectedActiveCheckboxBorderColor: currentTheme.labelTextColor,
                                            unselectedHoverCheckboxBorderColor: currentTheme.unselectedHoverCheckboxBorderColor,
                                        },
                                        paging: { BackgroundColor: currentTheme.listPaging },
                                        row: {
                                            ActiveBackgroundColor: currentTheme.listActiveRowColor,
                                            ActiveCellBorderColor: currentTheme.listActiveRowColor,
                                            ActiveColor: currentTheme.fieldTextColor,
                                            ActiveEditColor: currentTheme.fieldTextColor,
                                            GroupHeaderBackgroundColor: currentTheme.lightGray2,
                                            HoveredBackgroundColor: currentTheme.listRowHighlight,
                                            HoveredColor: currentTheme.fieldTextColor,
                                            InactiveBackgroundColor: currentTheme.light,
                                            MarkedBackgroundColor: currentTheme.listMarkRowColor,
                                            MarkedBackgroundHoverColor: currentTheme.listMarkRowHoverColor,
                                            MarkedColor: currentTheme.fieldTextColor,
                                        },
                                        scrollBarColor: currentTheme.scrollBarColor,
                                        scrollBarColorHover: currentTheme.scrollBarColorHover,
                                    },
                                    HoverBorderColor: currentTheme.toolbarHover,
                                    imageCard: { Border: currentTheme.light },
                                    input: { BackgroundColor: currentTheme.lightGray1, BackgroundColorEdit: currentTheme.lightGray0 },
                                    LabelColor: currentTheme.labelTextColor,
                                    list: {
                                        row: {
                                            ActiveBackgroundColor: currentTheme.accentDarkDark,
                                            ActiveColor: currentTheme.light,
                                            HoveredBackgroundColor: currentTheme.accentLightLight,
                                            HoveredColor: currentTheme.dark,
                                        },
                                    },
                                    listGrid: {
                                        sidePanel: {
                                            BackgroundColor: currentTheme.light,
                                        },
                                        TextColorOnFocus: currentTheme.fieldTextColor,
                                        TextColorOnHover: currentTheme.textColorOnHover,
                                        TextLink: currentTheme.reactGridLinkHover,
                                        TextLinkOnFocus: currentTheme.reactGridLink,
                                    },
                                    loadingIndicator: { Spinner: currentTheme.accentDarkDark },
                                    menuButton: {
                                        listItem: {
                                            BackgroundColor: currentTheme.light,
                                            EnabledHoverBackgroundColor: currentTheme.lightGray2,
                                        }
                                    },
                                    navigationBar: { hover: { BackgroundColor: currentTheme.lightGray } },
                                    navigationPane: { BackgroundColor: currentTheme.darkGray },
                                    OverlayBackgroundColor: currentTheme.appBarFlyoutBackground,
                                    PrimaryBorderColor: currentTheme.appBarBorderColor,
                                    search: { BackgroundColor: "transparent" },
                                    SecondaryButtonTextColor: currentTheme.darkGray,
                                    StaticTextLink: currentTheme.accent,
                                    TextColor: currentTheme.fieldTextColor,
                                    TextColorInverted: currentTheme.textOnAccent,
                                    TextColorOnFocus: currentTheme.fieldTextColor,
                                    TextColorOnHover: currentTheme.textColorOnHover,
                                    TextDisabled: currentTheme.disabled,
                                    TextLink: currentTheme.link,
                                    TextLinkOnFocus: currentTheme.linkInGridSelectedRow,
                                    TextLinkOnHover: currentTheme.reactGridLinkHover,
                                    TextLinkOnHoverSelected: currentTheme.linkRowSelectedHover,
                                    TextLinkSelected: currentTheme.linkInGridSelectedRow,
                                    TextSecondaryLight: currentTheme.darkGray9,
                                },
                                scaleFactor: $dyn.value($dyn.user().Density) / DensityThemeManager.baseDensity,
                            });
                            $(document).trigger("themechanged");
                        });
                    }
                };
                this._isThemeValid = function (theme) {
                    if (_this._themes.indexOf(theme.toString()) >= 0) {
                        return true;
                    }
                    return false;
                };
                this._isDensityValid = function (density) {
                    if (_this._densities.indexOf(density.toString()) >= 0) {
                        return true;
                    }
                    return false;
                };
                // Sets the default theme from the URL
                this._setDefautTheme = function () {
                    _this._previousDensity = "30";
                    _this._previousTheme = "0";
                };
                this._getCoreCssLink = function (densityValue, themeValue) {
                    var cssStyle = document.createElement("link");
                    var cssFileName;
                    cssStyle.rel = "stylesheet";
                    cssStyle.type = "text/css";
                    cssStyle.id = _this._getCssId("core", densityValue, themeValue);
                    var useRTL = Globalize.culture().isRTL || $dyn.debug.useRTL;
                    if (useRTL && $dyn.version.buildType === "debug") {
                        cssFileName = "core-rtl.css";
                    }
                    else if (useRTL) {
                        if ($dyn.version.fullVerString) {
                            cssFileName = "core-rtl.min-" + $dyn.version.fullVerString + ".css";
                        }
                        else {
                            cssFileName = "core-rtl.min.css";
                        }
                    }
                    else if ($dyn.version.buildType === "debug") {
                        cssFileName = "core.css";
                    }
                    else if ($dyn.version.fullVerString) {
                        cssFileName = "core.min-" + $dyn.version.fullVerString + ".css";
                    }
                    else {
                        cssFileName = "core.min.css";
                    }
                    cssStyle.href = $dyn.shell.rootPath + "Resources/themes/" + densityValue + "/" + themeValue + "/" + cssFileName;
                    return cssStyle;
                };
                this._getCssLink = function (densityValue, themeValue, cssInfoTypeObj) {
                    var cssStyle = document.createElement("link");
                    var cssFileName;
                    cssStyle.rel = "stylesheet";
                    cssStyle.type = "text/css";
                    var generatedCssId = _this._getCssId(cssInfoTypeObj.name, densityValue, themeValue);
                    var useRTL = Globalize.culture().isRTL || $dyn.debug.useRTL;
                    if (useRTL) {
                        cssFileName = cssInfoTypeObj.name + "-rtl.css";
                    }
                    else {
                        cssFileName = cssInfoTypeObj.name + ".css";
                    }
                    var generatedHref = "WebContent/" + cssInfoTypeObj.model + "/less/" + densityValue + "/" + themeValue + "/" + cssFileName;
                    // check for duplicate id's and href matches combined dont increment count if exact match
                    var themesFound = document.head.querySelectorAll("[id^=" + generatedCssId + '][href^="' + generatedHref + '"]');
                    if (themesFound.length === 0) {
                        // check for duplicate id's if so set an increment value based on number found
                        themesFound = document.head.querySelectorAll("[id^=" + generatedCssId + "]");
                        if (themesFound.length > 0) {
                            generatedCssId += "_" + themesFound.length;
                        }
                    }
                    cssStyle.href = $dyn.shell.rootPath + generatedHref;
                    cssStyle.id = generatedCssId;
                    return cssStyle;
                };
                /**
                 * Swaps the old theme with the new theme
                 * @param newThemeObj object containing new theme link references
                 * @param oldThemeObj object containing old theme link names
                 * @param currentDensity current density value
                 * @param currentTheme current theme value
                 */
                this._replaceTheme = function (newThemeObj, oldThemeObj, currentDensity, currentTheme) {
                    var splashScreenDisplayed = false;
                    if (_this._previousDensity.toString().length > 0 || _this._previousTheme.toString().length > 0) {
                        // Add new theme link only if it isn't already found
                        if (newThemeObj.coreLink && !document.getElementById(newThemeObj.coreLink.id)) {
                            _this._clearCurrentLocalTheme();
                            _this._saveCurrentLocalTheme(currentDensity, currentTheme);
                            // Get old themes
                            var oldCoreTheme = oldThemeObj.coreLink ? document.getElementById(oldThemeObj.coreLink.id) : null;
                            if (!oldCoreTheme) {
                                if (!$dyn.shell.isShellInitializing() &&
                                    _this._previousDensity !== _this._defaultDensity &&
                                    _this._previousTheme !== _this._defaultTheme) {
                                    // always one pass on clean boot since default isnt in place yet
                                    $dyn.logError("Shell: could not find old theme %s, density %s", _this._previousTheme, _this._previousDensity);
                                }
                            }
                            if (!$dyn.shell.isSingleThemed) {
                                $("#mainContainer").fadeOut($dyn.ui.motionTiming.basic);
                            }
                            var noCssReceivedID_1 = $dyn.async(function () {
                                if (!$dyn.shell.hideSplash) {
                                    $("#splashScreen").fadeOut($dyn.ui.motionTiming.basic, function () {
                                        splashScreenDisplayed = false;
                                        $("#mainContainer").fadeIn($dyn.ui.motionTiming.basic);
                                        noCssReceivedID_1 = undefined;
                                    });
                                    $dyn.logError("Shell: did not receive CSS prior to timeout from server");
                                }
                            }, 20000);
                            var showSplashID_1 = $dyn.async(function () {
                                if (!$dyn.shell.hideSplash && !$dyn.shell.isSingleThemed) {
                                    console.log("app:" + performance.now());
                                    $("#splashScreen").css("visibility", "visible");
                                    $("#splashScreen").css("display", "block");
                                    splashScreenDisplayed = true;
                                    showSplashID_1 = undefined;
                                    $("#splashScreen").fadeIn($dyn.ui.motionTiming.basic);
                                }
                            }, 1500);
                            // append any custom requested themes
                            _this._appendCustomCss(currentDensity, currentTheme);
                            // make sure what we add isnt already there
                            if (!document.getElementById(newThemeObj.coreLink.id)) {
                                $dyn.async.pending.increment("Adding new Theme file to body");
                                document.head.appendChild(newThemeObj.coreLink);
                                newThemeObj.coreLink.onload = function () {
                                    if (noCssReceivedID_1) {
                                        noCssReceivedID_1.cancel();
                                    }
                                    if (showSplashID_1) {
                                        showSplashID_1.cancel();
                                    }
                                    setTimeout(function () {
                                        _this._cleanupThemesInDom(newThemeObj);
                                        $dyn.async.pending.decrement("Adding new Theme file to body");
                                    });
                                    if (splashScreenDisplayed) {
                                        $("#splashScreen").fadeOut($dyn.ui.motionTiming.basic);
                                        splashScreenDisplayed = false;
                                    }
                                    $("#mainContainer").fadeIn($dyn.ui.motionTiming.basic);
                                    if ($dyn.util.isFlightEnabled($dyn.reactGrid.featureName)) {
                                        // Also update react theme
                                        _this.updateReactTheme();
                                    }
                                };
                            }
                            else {
                                if (splashScreenDisplayed) {
                                    $("#splashScreen").fadeOut($dyn.ui.motionTiming.basic);
                                    splashScreenDisplayed = false;
                                }
                                $("#mainContainer").fadeIn($dyn.ui.motionTiming.basic);
                            }
                        }
                    }
                };
                /**
                 * Cleans our old custom css links
                 */
                this._cleanCustomCss = function () {
                    // if any exist
                    if ($dyn.appConfig && $dyn.appConfig.styles) {
                        var customNewCssId = void 0;
                        for (var styleLink in $dyn.appConfig.styles) {
                            if ($dyn.appConfig.styles[styleLink].name && $dyn.appConfig.styles[styleLink].model) {
                                // build old theme link
                                customNewCssId = _this._getCssId($dyn.appConfig.styles[styleLink].name, _this._previousDensity, _this._previousTheme);
                                _this._clearOldTheme(customNewCssId, $dyn.appConfig.styles[styleLink].name);
                            }
                        }
                    }
                };
                /**
                 * Append custom defined css files and clear old ones out
                 * @param currentDensity current density value
                 * @param currentTheme current theme value
                 */
                this._appendCustomCss = function (currentDensity, currentTheme) {
                    // if any exist
                    if ($dyn.appConfig && $dyn.appConfig.styles) {
                        var customNewCssLink = void 0;
                        for (var styleLink in $dyn.appConfig.styles) {
                            if ($dyn.appConfig.styles[styleLink].name && $dyn.appConfig.styles[styleLink].model) {
                                // create new theme link
                                // tslint:disable-next-line: max-line-length
                                customNewCssLink = _this._getCssLink(currentDensity, currentTheme, { cssName: styleLink, name: $dyn.appConfig.styles[styleLink].name, model: $dyn.appConfig.styles[styleLink].model });
                                // append new
                                document.head.appendChild(customNewCssLink);
                            }
                        }
                    }
                };
                /**
                 * Removes any old CSS for Core - but only if the new one is found, and only keeps the ones that just got added
                 * @param newThemeId Theme Id to find
                 * @param themeName Theme name to match
                 */
                this._clearOldTheme = function (newThemeId, themeName) {
                    var currentSelector = 0;
                    // we only want to have the current theme live, so delete any old ones
                    // remove old themes if they were found
                    // check app themes to remove
                    // does the new key exist if so delete old ones
                    if (document.head.querySelectorAll("[id=" + newThemeId + "]")[0]) {
                        var themesFound = document.head.querySelectorAll("[id^=" + themeName + "_]");
                        if (themesFound.length > 0) {
                            for (currentSelector = 0; currentSelector < themesFound.length; currentSelector++) {
                                if (themesFound[currentSelector].id !== newThemeId) {
                                    themesFound[currentSelector].remove();
                                }
                            }
                        }
                    }
                };
                /**
                 * Removes any old CSS for Core
                 * @param newThemeToKeep object containing new theme link references
                 */
                this._cleanupThemesInDom = function (newThemeToKeepObj) {
                    // clear core
                    _this._clearOldTheme(newThemeToKeepObj.coreLink.id, "core");
                    // check custom css
                    _this._cleanCustomCss();
                };
                // Validates the theme and density returning the defaults if they are not valid
                this._getValidThemeAndDensity = function (theme, density) {
                    if (theme == null || !_this._isThemeValid(theme)) {
                        theme = _this._defaultTheme;
                    }
                    if (density == null || !_this._isDensityValid(density)) {
                        density = _this._defaultDensity;
                    }
                    return { "theme": theme, "density": density };
                };
            }
            DensityThemeManager.prototype._saveCurrentLocalTheme = function (densityValue, themeValue) {
                if ($dyn.shell.canUseLocalStorage) {
                    try {
                        localStorage.setItem("theme", JSON.stringify({
                            cssLinkDensity: densityValue,
                            cssLinkTheme: themeValue
                        }));
                    }
                    catch (e) {
                        $dyn.util.localStorageErorrHandler(e.name);
                    }
                }
            };
            DensityThemeManager.prototype._clearCurrentLocalTheme = function () {
                if ($dyn.shell.canUseLocalStorage) {
                    localStorage.removeItem("theme");
                }
            };
            DensityThemeManager.baseDensity = 30;
            return DensityThemeManager;
        }());
        shell.DensityThemeManager = DensityThemeManager;
    })(shell = $dyn.shell || ($dyn.shell = {}));
    $dyn.densityThemeManager = new $dyn.shell.DensityThemeManager();
})($dyn || ($dyn = {}));

//# sourceMappingURL=DensityThemeManager.js.map
